export { default } from './AreaManagement';
